import "core-js/modules/es6.regexp.replace";
/* eslint-disable */
import { toQueryString, pressEvent } from '@ykz/ykz-util/base';
import { isWX, isYkzMiniprogram } from '@ykz/ykz-util/platform';
import databus, { Origins } from '@ykz/ykz-http/core';
import { verifyPopularizer } from '@ykz/ykz-http/common';
export default {
  name: 'auto_register',
  data: function data() {
    return {
      showAutoRegister: false,
      //是否显示一键注册弹框
      showOutAnimation: false,
      //展示关闭弹框动画
      isWx: isWX(),
      //是否在微信公众号环境
      isMini: isYkzMiniprogram(),
      //是否在微信小程序环境
      qrCodeUrl: '',
      //公众号二维码
      isPressQrCode: false //是否长按识别或保存过二维码，默认false
    };
  },

  props: ['saveMoney'],
  watch: {
    showAutoRegister: function showAutoRegister(val) {
      this.setOverflow(val);
    }
  },
  mounted: function mounted() {
    var _this = this;
    setTimeout(function () {
      _this.getAutoRegisterQrCodeByPullNew();
    }, 1000);
  },
  methods: {
    //隐藏弹框
    hideBox: function hideBox() {
      var _this2 = this;
      var timer = null;
      this.showOutAnimation = true;
      timer = setTimeout(function () {
        clearTimeout(timer);
        _this2.showOutAnimation = false;
        _this2.showAutoRegister = false;
        _this2.isPressQrCode && _this2.judgeWhetherBePromoter();
      }, 200);
    },
    //兼容ios系统的overflow对z-index层级关系的影响
    setOverflow: function setOverflow(val) {
      if (val) {
        $('.scroll-area').css('overflow-y', 'hidden');
      } else {
        $('.scroll-area').css('overflow-y', 'auto');
      }
    },
    //打锚点
    reportUserAnchors: function reportUserAnchors(element_content) {
      YCF_Plugin.reportUserAnchors({
        event_id: '400001',
        properties: {
          element_content: element_content
        }
      });
    },
    //获取商品拉新自动注册二维码
    getAutoRegisterQrCodeByPullNew: function getAutoRegisterQrCodeByPullNew() {
      var _this3 = this;
      databus({
        url: '/apiv2/marketing/getAutoRegisterQrCodeByPullNew',
        type: 'post',
        data: {
          userId: window.userId,
          promotion: getUrlParams('promotion') || '',
          productId: getUrlParams('goodId') || ''
        },
        success: function success(res) {
          if (res.code == 1000 && res.bcode == 100) {
            _this3.qrCodeUrl = res.content.qrCodeUrl || '';
            _this3.$nextTick(function () {
              _this3.showAutoRegister = true;
              pressEvent('.component-auto-register img.register-erweima', function () {
                _this3.reportUserAnchors('长按扫码进入公众号');
                _this3.isPressQrCode = true;
              });
            });
          }
        }
      });
    },
    //判断是否用户已注册成功
    judgeWhetherBePromoter: function judgeWhetherBePromoter() {
      verifyPopularizer().then(function () {
        if (this.isMini) {
          location.replace(location.href + '&' + toQueryString({
            time: new Date().getTime()
          }));
        } else {
          location.reload();
        }
        sessionStorage.setItem('byPullNewPageReload', 1); //C用户通过拉新页面一键注册成为推广员，刷新页面后，需要隐藏海报按钮，保存到session
      });
    }
  }
};